import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  GetClubPasswordResponse,
  HGFounderClubPasswordReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

const useGetClubPassword = (clubId: number) => {
  const request = useRequest();
  const [loading, setLoading] = useState(false);
  const [clubPassword, setClubPassword] = useState<string>();

  useEffect(() => {
    setLoading(true);
    request({
      service: 'homeGames.getClubPassword',
      body: { clubId }
    }).subscribe(({ body }) => {
      const {
        error,
        data: { password }
      } = handleServerResponse<GetClubPasswordResponse, HGFounderClubPasswordReply>({
        response: body,
        accessor: 'clubPasswordReply'
      });
      if (!error && password) {
        setClubPassword(password);
      }

      setLoading(false);
    });
  }, [clubId, request]);

  return { loading, clubPassword };
};

export default useGetClubPassword;
